import { Shipment } from '@/lib/index';

export const sampleShipments: Shipment[] = [
  {
    id: '1',
    trackingNumber: 'L71WWX8FH',
    recipient: {
      name: 'Katarzyna Brozyna Lyb',
      address: '41564 Kaarst, Büttgenerstr. 17',
    },
    amount: {
      payout: 220642.00,
      deposit: 19858.00,
      total: 240500.00,
      currency: 'EUR',
    },
    status: 'unpaid',
    deliveryType: 'Dostawa Ekspresowa',
    createdAt: '2026-02-20',
    estimatedDelivery: '2026-02-28',
  },
  {
    id: '2',
    trackingNumber: 'EH2026001',
    recipient: {
      name: 'Jan Kowalski',
      address: '00-001 Warszawa, ul. Marszałkowska 1',
    },
    amount: {
      payout: 15000.00,
      deposit: 1500.00,
      total: 16500.00,
      currency: 'EUR',
    },
    status: 'in_transit',
    deliveryType: 'Dostawa Ekspresowa',
    createdAt: '2026-02-25',
    estimatedDelivery: '2026-02-27',
  },
  {
    id: '3',
    trackingNumber: 'EH2026002',
    recipient: {
      name: 'Anna Nowak',
      address: '30-001 Kraków, ul. Floriańska 10',
    },
    amount: {
      payout: 50000.00,
      deposit: 4500.00,
      total: 54500.00,
      currency: 'EUR',
    },
    status: 'paid',
    deliveryType: 'Dostawa Standard',
    createdAt: '2026-02-15',
    estimatedDelivery: '2026-02-22',
  },
];

export const services = [
  {
    id: '1',
    title: 'Przekazy Gotówkowe',
    description: 'Bezpieczne dostarczanie indywidualnych przekazów gotówkowych na terenie całej Europy. Gwarantujemy pełne ubezpieczenie i śledzenie przesyłki w czasie rzeczywistym.',
    features: [
      'Pełne ubezpieczenie kwoty',
      'Śledzenie w czasie rzeczywistym',
      'Profesjonalna obsługa kurierska',
      'Potwierdzenie odbioru',
    ],
    icon: 'money',
  },
  {
    id: '2',
    title: 'Dostawa Ekspresowa',
    description: 'Najszybsza forma dostawy - przesyłka dociera do odbiorcy w ciągu 24-48 godzin. Idealne rozwiązanie dla pilnych przekazów finansowych.',
    features: [
      'Dostawa w 24-48h',
      'Priorytetowe traktowanie',
      'Dedykowany kurier',
      'SMS z powiadomieniem',
    ],
    icon: 'express',
  },
  {
    id: '3',
    title: 'Dostawa Standard',
    description: 'Ekonomiczna opcja dostawy z gwarancją bezpieczeństwa. Przesyłka dociera w ciągu 3-5 dni roboczych.',
    features: [
      'Dostawa w 3-5 dni',
      'Konkurencyjne ceny',
      'Pełne ubezpieczenie',
      'Śledzenie online',
    ],
    icon: 'standard',
  },
  {
    id: '4',
    title: 'Kaucja Ubezpieczeniowa',
    description: 'Każda przesyłka zabezpieczona jest kaucją ubezpieczeniową, która gwarantuje zwrot środków w przypadku nieprzewidzianych sytuacji.',
    features: [
      'Automatyczna kaucja',
      'Zwrot w 48h',
      'Pełna transparentność',
      'Bez ukrytych opłat',
    ],
    icon: 'security',
  },
];

export const companyInfo = {
  name: 'EXPRESS HUB',
  tagline: 'Bezpieczne przekazy gotówkowe na terenie Europy',
  description: 'EXPRESS HUB to wiodąca firma kurierska specjalizująca się w dostarczaniu indywidualnych przekazów gotówkowych. Działamy na terenie całej Europy, zapewniając najwyższy poziom bezpieczeństwa i profesjonalizmu.',
  mission: 'Naszą misją jest zapewnienie bezpiecznego i szybkiego transferu środków finansowych, budując zaufanie poprzez transparentność, profesjonalizm i najwyższe standardy obsługi klienta.',
  values: [
    {
      title: 'Bezpieczeństwo',
      description: 'Każda przesyłka jest w pełni ubezpieczona i monitorowana 24/7',
    },
    {
      title: 'Transparentność',
      description: 'Pełna widoczność statusu przesyłki i kosztów bez ukrytych opłat',
    },
    {
      title: 'Profesjonalizm',
      description: 'Wykwalifikowany zespół kurierów i obsługi klienta',
    },
    {
      title: 'Szybkość',
      description: 'Ekspresowa dostawa w 24-48 godzin na terenie Europy',
    },
  ],
  contact: {
    email: 'support@expresshub.pro',
    phone: '+48 22 263 91 91',
    phones: [
      {
        country: 'Polska',
        number: '+48 22 263 91 91'
      },
      {
        country: 'Szwajcaria',
        number: '+41 415 331 634'
      }
    ],
    address: 'Via Vite, 6, Stabio, 6883 Novazzano, Szwajcaria',
    hours: 'Pon-Pt: 8:00-18:00, Sob-Nd: 11:00-16:00',
  },
  stats: [
    {
      value: '50,000+',
      label: 'Zrealizowanych przesyłek',
    },
    {
      value: '€500M+',
      label: 'Bezpiecznie dostarczonych środków',
    },
    {
      value: '15',
      label: 'Krajów obsługi',
    },
    {
      value: '99.8%',
      label: 'Zadowolonych klientów',
    },
  ],
};
